/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CBCRemediationSpec } from './cBCRemediationSpec';
import { CWSRemediationSpec } from './cWSRemediationSpec';
import { VMCARemediationSpec } from './vMCARemediationSpec';
import { ResourceProvider } from './resourceProvider';
import { CBCRemediationSpecByolCredentials } from './cBCRemediationSpecByolCredentials';
import { CBCRemediationSpecRemediateRegionalCredentials } from './cBCRemediationSpecRemediateRegionalCredentials';


/**
 * @type RemediateResourceParamsSpec
 * @export
 */
export type RemediateResourceParamsSpec = CBCRemediationSpec | CWSRemediationSpec | VMCARemediationSpec;

